// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_categories = /** @type {(inputs: {}) => string} */ () => {
	return `Categories`
};

const el_categories = /** @type {(inputs: {}) => string} */ () => {
	return `Κατηγορίες`
};

const ru_categories = /** @type {(inputs: {}) => string} */ () => {
	return `Категории`
};

const he_categories = /** @type {(inputs: {}) => string} */ () => {
	return `קטגוריות`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const categories = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.categories(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("categories", locale)
	if (locale === "en") return en_categories(inputs)
	if (locale === "el") return el_categories(inputs)
	if (locale === "ru") return ru_categories(inputs)
	if (locale === "he") return he_categories(inputs)
	return "categories"
};